import { RequestParam } from '../../models/RequestParam';
import { UseCase } from '../UseCase';
import { SellRepository } from '../../repositories/SellRepository';
import { SkuDetail } from '../../models/SkuDetail';

export class SellUseCase implements UseCase<RequestParam[], SkuDetail>{

    constructor(
        private sellRepo: SellRepository
    ) { }

    execute(t: RequestParam[]): Promise<SkuDetail> {
        return this.sellRepo.sell(t);
    }

}